var _templateObject = _taggedTemplateLiteralLoose(['\n  h5 {\n    color: #fff;\n    margin-bottom: 0px;\n  }\n  ul {\n    margin-left: 0px;\n  }\n  li {\n    list-style: none;\n  }\n'], ['\n  h5 {\n    color: #fff;\n    margin-bottom: 0px;\n  }\n  ul {\n    margin-left: 0px;\n  }\n  li {\n    list-style: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  h5 {\n    margin-bottom: 0px;\n    color: #fff;\n  }\n  p {\n    color: #fff;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  h5 {\n    margin-bottom: 0px;\n    color: #fff;\n  }\n  p {\n    color: #fff;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  padding-top: 24px;\n  color: ', ';\n  @media (max-width: 768px) {\n    flex-direction: column;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n  a {\n    color: ', ';\n    width: 100%;\n    transition: all 0.25s ease-in-out;\n    &:hover {\n      color: ', ';\n    }\n  }\n'], ['\n  display: flex;\n  padding-top: 24px;\n  color: ', ';\n  @media (max-width: 768px) {\n    flex-direction: column;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n  a {\n    color: ', ';\n    width: 100%;\n    transition: all 0.25s ease-in-out;\n    &:hover {\n      color: ', ';\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import SocialLinks from './SocialLinks/index';
import styled from 'styled-components';
import { organiseColumnsIntoPairs } from './helpers';
import FooterLogos from '../../FooterLogos';
import Wrapper from '../../Wrapper';
import { GradientPrimary } from '../../Containers';
var Column = styled.div(_templateObject);
var ColumnWrapper = styled.div(_templateObject2);
var Main = styled.footer(_templateObject3, function (props) {
  return props.theme.colours.neutral.lightest;
}, function (props) {
  return props.theme.colours.primary.lightest;
}, function (props) {
  return props.theme.colours.primary.lighter;
});

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Footer.prototype.render = function render() {
    var _props = this.props,
        copywriter = _props.copywriter,
        underwriter = _props.underwriter,
        address = _props.address,
        showOmart = _props.showOmart;
    var columns = organiseColumnsIntoPairs(this.props.columns);

    var createColumn = function createColumn(column, ColumnIndex) {
      return React.createElement(Column, {
        key: ColumnIndex
      }, React.createElement('h5', null, column.title), React.createElement('ul', null, column.links.map(function (link, index) {
        return React.createElement('li', {
          key: index
        }, link);
      })));
    };

    return React.createElement(React.Fragment, null, React.createElement(GradientPrimary, null, showOmart && React.createElement(FooterLogos, this.props), React.createElement(Wrapper, null, React.createElement(Main, null, columns.map(function (chunk, index) {
      return React.createElement(ColumnWrapper, {
        key: index
      }, chunk.map(function (column, columnIndex) {
        return createColumn(column, columnIndex);
      }));
    }), React.createElement(ColumnWrapper, null, React.createElement(SocialLinks, {
      links: address.socialLinks
    }), React.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: address.lines
      }
    }), React.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: address.contactNumbersHtml
      }
    }))))));
  };

  return Footer;
}(Component);

export default Footer;